import { createSelector } from 'reselect'

import userShouldSeeVideoLessonsSelector from 'redux/selectors/user/user_should_see_video_lessons_selector'
import viewTypes from 'helpers/enums/viewTypes'

const getUI = state => state.ui

const userShouldBeRedirectedToMyLibrary = createSelector(
	[ getUI, userShouldSeeVideoLessonsSelector ],
	(ui, userShouldSeeVideoLessons) => {
		let shouldBeRedirected = false
		switch (ui.currentView) {
			case viewTypes.INTERACTIVE_VIDEO_SELECT:
			case viewTypes.INTERACTIVE_VIDEO_CREATE:
				shouldBeRedirected = !userShouldSeeVideoLessons
		}
		return shouldBeRedirected
	}
)

export default userShouldBeRedirectedToMyLibrary
